import styled from 'styled-components';
import { Image as SemanticImage } from 'semantic-ui-react';

export const Image = styled(SemanticImage)`
  ${({ isEdit }) => (isEdit ? '' : 'cursor: pointer;')};
  height: 20px;
  width: 20px;
`;
